import React, { FC } from 'react';
import Router from 'next/router';
import { StickyFooter } from '@/StickyFooter';
import ErrorLayout from '../layouts/Error.layout';
import Button from '@/components/Button/Button';

interface IErrorOfflineProps {
  className?: string;
  onClick?: () => void;
}

const ErrorOffline: FC<IErrorOfflineProps> = ({ className, onClick }) => (
  <ErrorLayout
    className={className}
    description="لطفا دسترسی دستگاه خود به اینترنت را بررسی کنید."
    title="عدم اتصال به اینترنت"
    type="offline"
  >
    <StickyFooter>
      <Button
        className="mt-auto"
        variant="outline"
        isFullWidth
        onClick={onClick ? () => onClick?.() : () => Router.reload()}
      >
        تلاش مجدد
      </Button>
    </StickyFooter>
  </ErrorLayout>
);

export default ErrorOffline;
